import $ from "jquery"

const Config = {
	debug: false,
	version: version,
	env: env,
	proxy: "",
	publicPath: "typo3conf/ext/" + publicPath + "/Resources/",
	documentRoot: "/",
	module: {
		external: [
			{
				selector: ".bb-iframe-resizer",
				css: [],
				js: [
					{
						url: "typo3conf/ext/bb_iframe/Resources/Public/Scripts/iframeResizer.min.js",
						crossDomain: false,
						loadedCallback: () => {
							window.iFrameResize({ log: false, checkOrigin: false })
						},
					},
				],
			},
		],
	},
	map: {
		key: "AIzaSyC9I7lu5NUrc9H1bwdW9EpgNVd5qT6h3rA",
	},
	faq: {
		searchMinChar: 3,
		highlightClass: "search-hit",
	},
	medienportal: {
		resultPerPage: 10,
		pagination: {
			numberPrevItems: 2,
			numberNextItems: 2,
		},
	},
}

export default $.extend(true, Config, window.bbConfig)
